export default __webpack_public_path__ + "static/media/Robot-gif.54e9f948.gif";